/* eslint-disable no-undef */

/**
 * This file defines and exports build flags.
 * Webpack will replace variable references with actual values during bundling using the DefinePlugin. Its important to
 * note that aliases are NOT replaced by the DefinePlugin.
 *
 * However, this replacement won't occur in files not processed by Webpack. When files are loaded directly by the
 * browser, Webpack is configured to compile this file and replace the symbols here. In other files, the symbols will
 * be imported from this file.
 *
 * Fallback are provided for when webpack is not in the loop, e.g., Playwright tests importing sources directly.
 */

const _BUILD_FLAG__MINIFIED_BUILD = typeof BUILD_FLAG__MINIFIED_BUILD !== 'undefined' ? BUILD_FLAG__MINIFIED_BUILD : false;
const _BUILD_FLAG__BUILD_VERSION = typeof BUILD_FLAG__BUILD_VERSION !== 'undefined' ? BUILD_FLAG__BUILD_VERSION : 'local';
const _BUILD_FLAG__IS_NODEJS_BUILD = typeof BUILD_FLAG__IS_NODEJS_BUILD !== 'undefined' ? BUILD_FLAG__IS_NODEJS_BUILD : false;
const _BUILD_FLAG__ENABLE_ANALYTICS = typeof BUILD_FLAG__ENABLE_ANALYTICS !== 'undefined' ? BUILD_FLAG__ENABLE_ANALYTICS : false;

export {
  _BUILD_FLAG__MINIFIED_BUILD as BUILD_FLAG__MINIFIED_BUILD,
  _BUILD_FLAG__BUILD_VERSION as BUILD_FLAG__BUILD_VERSION,
  _BUILD_FLAG__IS_NODEJS_BUILD as BUILD_FLAG__IS_NODEJS_BUILD,
  _BUILD_FLAG__ENABLE_ANALYTICS as BUILD_FLAG__ENABLE_ANALYTICS };